export enum FilterType {
  RANGE = 'RANGE',
  MULTIVALUED = 'MULTI-VALUED',
  VALUE = 'VALUE',
  CONTAINER = 'CONTAINER',
  MONOVALUED = 'MONO-VALUED-WITH-DEFAULT',
  BOOLEAN = 'BOOLEAN',
  ACTOR = 'ACTOR',
}
